import React, { useEffect, useRef, useState } from "react";
import { NotebookPen, Check, Lock } from "lucide-react";

const STORAGE_PREFIX = "diario_oracao_";

export const PrayerDiary = ({ number }) => {
  const key = `${STORAGE_PREFIX}${String(number).padStart(2, "0")}`;
  const [text, setText] = useState("");
  const [saved, setSaved] = useState(false);
  const savedTimer = useRef(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(key);
      setText(stored || "");
    } catch (e) {
      setText("");
    }
    setSaved(false);
  }, [key]);

  useEffect(() => () => savedTimer.current && clearTimeout(savedTimer.current), []);

  const handleSave = () => {
    try {
      if (text.trim()) {
        localStorage.setItem(key, text);
      } else {
        localStorage.removeItem(key);
      }
      setSaved(true);
      savedTimer.current && clearTimeout(savedTimer.current);
      savedTimer.current = setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      /* localStorage indisponível — falha silenciosa */
    }
  };

  return (
    <section
      data-testid="prayer-diary"
      className="w-full bg-[#FAF7F2] rounded-3xl p-6 sm:p-8 border border-[#E5DCCF] shadow-sm mt-8 fade-up delay-2"
    >
      <div className="flex items-center gap-2.5 mb-1.5">
        <NotebookPen className="w-5 h-5 text-[#C5A059]" strokeWidth={1.8} />
        <h3
          data-testid="prayer-diary-title"
          className="font-serif-display text-xl sm:text-2xl text-[#3A2921] font-semibold"
        >
          Meu diário de oração
        </h3>
      </div>

      <p className="flex items-center gap-1.5 text-xs text-[#9C877A] mb-4">
        <Lock className="w-3 h-3" strokeWidth={2} />
        Só você vê. Fica salvo neste aparelho, de forma privada.
      </p>

      <textarea
        data-testid="prayer-diary-textarea"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          setSaved(false);
        }}
        placeholder="Escreva aqui seu pedido, sua gratidão ou o que sentiu ao ouvir esta oração..."
        rows={5}
        className="w-full resize-none rounded-2xl border border-[#E5DCCF] bg-white/70 px-4 py-3 text-sm sm:text-base text-[#3A2921] placeholder:text-[#B8A899] leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#C5A059]/40 focus:border-[#C5A059]/60 transition"
      />

      <div className="mt-4 flex items-center justify-end gap-3">
        {saved && (
          <span
            data-testid="prayer-diary-saved-msg"
            className="inline-flex items-center gap-1.5 text-sm text-[#7A8B6F] fade-up"
          >
            <Check className="w-4 h-4" strokeWidth={2.5} /> Salvo com carinho
          </span>
        )}
        <button
          type="button"
          data-testid="prayer-diary-save-button"
          onClick={handleSave}
          className="inline-flex items-center gap-2 rounded-full bg-[#3A2921] px-6 py-2.5 text-sm font-medium text-[#F7F2E9] tracking-wide hover:bg-[#513a2f] active:scale-[0.98] transition-all"
        >
          <NotebookPen className="w-4 h-4" strokeWidth={2} /> Salvar
        </button>
      </div>
    </section>
  );
};
